const state = {
  userInfo: {},
  userInMallStatus: {}
}
export const getters = {
  // 用户是否可以免费使用模板
  userCanFreeUseTemplate: ({ userInMallStatus }) => {
    return userInMallStatus.isFreeUseTemplate
  },
  // 用户是否可以购买会员
  userCanBuyMember: ({ userInMallStatus }) => {
    return userInMallStatus.canBuyMember
  },
  // 付费子账号
  subAccoutNeedPay: ({ userInMallStatus }) => {
    return userInMallStatus.subAccountType === 1
  }
}

const mutations = {
  setUserInfo (state, { userInfo }) {
    state.userInfo = userInfo
  },
  setUserInMallStatus (state, { userInMallStatus }) {
    state.userInMallStatus = userInMallStatus
  }
}

const actions = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
